import axios from "axios";
import React, { useEffect, useState } from "react";
import { BASE_URL } from "../../config/axios";
import { customSortByKey, handleAllError } from "../CustomFunctions";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import { BlueEye, SearchSmall } from "../AllSvg";



const EmployeesforDashboardData = ({ data, title, subcompany, empstatus, emptype, month, year }) => {
  const [show, setShow] = useState(false);
  const [buffer, setBuffering] = useState(true); //buffering logic

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
    getDashboardEmployees();
  };

  const [dashboardEmployees, setDashboardEmployees] = useState([]);

  const getDashboardEmployees = async () => {
    setBuffering(true); //buffering logic // Start Buffering 
    try {
      // const res = await axios.get(
      //   // `${BASE_URL}/wfm/showemployeedata/${subcompany || 'null'}/${empstatus || 'null'}/${emptype || 'null'}/${month || 'null'}/${year || 'null'}/`
      //   `${BASE_URL}/wfm/employeestatusbysubcompanyv3/${month || 'null'}/${year || 'null'}/${subcompany || 'null'}/`
      // );
      // const sortedList = customSortByKey(res.data, "emp_code");

      // setDashboardEmployees(sortedList);
      setDashboardEmployees([]);
    } catch (err) {
      handleAllError(err);
    } finally {
      setBuffering(false);
    }
  };

  const [searchQuery, setSearchQuery] = useState("");
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const navigate = useNavigate();

  const currentUrl = window.location.href;
  const urlParts = currentUrl.split('/');
  const url = urlParts[3]

  const Viewdetails = (emp_code, user_detail) => {
    navigate(`/${url}/userdetailscrud/${emp_code}/${user_detail}/`);
  };
  return (
    <>
      <button
        className=""
        title="View Employees"
        style={{ paddingLeft: "5px", color: "blue", fontSize: "14px" }}
        onClick={handleShow}
      >
        <BlueEye />
      </button>
      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Body>
          <>
            {/* <div className="attendance-history-cont">
              <div className="attendance-heading  font-weight500    font-size-heading"></div>
            </div> */}
            <div className="table-css-white-background">
              <div className="table-heading-flex">
                <div className="repo-heading font-weight500    font-size-heading">
                  {/* Employees for : <br /> */}
                  {title} ({data?.filter(
                    (e) =>
                      e.name
                        .toLowerCase()
                        .includes(searchQuery.toLowerCase()) ||
                      e.emp_code
                        .toString()
                        .includes(searchQuery.toLowerCase())
                  ).length}/{data.length})
                </div>
                <div className="flex-row">
                  <div className="table-searchh">
                    <div>
                      <SearchSmall />
                    </div>
                    <div>
                      <input
                        placeholder="Search"
                        className="navbar-inputt font-weight400  font-size-text"
                        value={searchQuery}
                        onChange={handleSearchChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <table className="table-css">
                <thead>
                  <tr className="custom-table-head-tr">
                    <th className="align-left">ID</th>
                    <th className="align-center">Emp Code</th>
                    <th className="align-center"> Name </th>
                    <th className="align-center">Employee View</th>
                  </tr>
                </thead>
                {buffer ? <div className="spinner"></div> : //buffering logic
                  <tbody>
                    {data
                      ?.filter(
                        (e) =>
                          e.name
                            .toLowerCase()
                            .includes(searchQuery.toLowerCase()) ||
                          e.emp_code
                            .toString()
                            .includes(searchQuery.toLowerCase())
                      )
                      .sort((a, b) => a.emp_code - b.emp_code)
                      .map((i, index) => (
                        <React.Fragment key={index}>
                          {/* <tr className="tr-border-bottom">
                          <td colSpan="6"></td>
                        </tr> */}
                          <tr className="custom-table-head-td">
                            <td className="align-left">{index + 1}</td>
                            <td className="align-center">{i.emp_code}</td>
                            <td className="align-center">{i.name}</td>

                            <td className="align-center">
                              <button
                                className="employee-edit"
                                onClick={() =>
                                  Viewdetails(i.emp_code, i.user_detail)
                                }
                                title="View Profile"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="40"
                                  height="40"
                                  viewBox="0 0 30 30"
                                  fill="none"
                                >
                                  <circle cx="15" cy="15" r="15" fill="#F6F7F9" />
                                  <path
                                    d="M23.8913 14.5437C22.1966 11.2372 18.8416 9 15 9C11.1584 9 7.80249 11.2388 6.10873 14.5441C6.03725 14.6855 6 14.8417 6 15.0002C6 15.1586 6.03725 15.3148 6.10873 15.4563C7.80342 18.7628 11.1584 21 15 21C18.8416 21 22.1975 18.7612 23.8913 15.4559C23.9628 15.3145 24 15.1583 24 14.9998C24 14.8414 23.9628 14.6852 23.8913 14.5437ZM15 19.5C14.11 19.5 13.24 19.2361 12.4999 18.7416C11.7599 18.2471 11.1831 17.5443 10.8425 16.7221C10.5019 15.8998 10.4128 14.995 10.5865 14.1221C10.7601 13.2492 11.1887 12.4474 11.818 11.818C12.4474 11.1887 13.2492 10.7601 14.1221 10.5865C14.995 10.4128 15.8998 10.5019 16.7221 10.8425C17.5443 11.1831 18.2472 11.7599 18.7416 12.4999C19.2361 13.24 19.5 14.11 19.5 15C19.5003 15.591 19.3841 16.1763 19.1581 16.7224C18.932 17.2685 18.6005 17.7647 18.1826 18.1826C17.7647 18.6005 17.2685 18.932 16.7224 19.158C16.1763 19.3841 15.591 19.5003 15 19.5ZM15 12C14.7322 12.0037 14.4662 12.0436 14.2091 12.1184C14.421 12.4065 14.5227 12.7609 14.4957 13.1175C14.4688 13.4741 14.3149 13.8092 14.062 14.062C13.8092 14.3149 13.4741 14.4688 13.1175 14.4957C12.7609 14.5227 12.4065 14.421 12.1184 14.2091C11.9544 14.8133 11.984 15.4538 12.2031 16.0403C12.4221 16.6269 12.8196 17.1299 13.3396 17.4787C13.8595 17.8275 14.4758 18.0045 15.1016 17.9847C15.7274 17.965 16.3312 17.7495 16.8281 17.3685C17.325 16.9876 17.6899 16.4604 17.8715 15.8612C18.0531 15.2621 18.0422 14.621 17.8404 14.0283C17.6386 13.4356 17.256 12.9211 16.7465 12.5573C16.2369 12.1934 15.6261 11.9985 15 12Z"
                                    fill="#2576BC"
                                  />
                                </svg>
                              </button>
                            </td>
                          </tr>
                        </React.Fragment>
                      ))}
                  </tbody>
                }
              </table>
            </div>
          </>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </Modal.Body>
      </Modal>
    </>
  );
};

const EmployeeforDashboardDataOnboarding = ({ title, subcompany, month, year }) => {
  const [show, setShow] = useState(false);
  const [buffer, setBuffering] = useState(true); //buffering logic

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
    getDashboardEmployees();
  };

  const [dashboardEmployees, setDashboardEmployees] = useState([]);

  const getDashboardEmployees = async () => {
    setBuffering(true); //buffering logic // Start Buffering 
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/onbordingemployees/${subcompany || 'null'}/${month || 'null'}/${year || 'null'}`
      );
      const sortedList = customSortByKey(res.data, "emp_code");

      setDashboardEmployees(sortedList);
    } catch (err) {
      handleAllError(err);
    } finally {
      setBuffering(false);
    }
  };

  const [searchQuery, setSearchQuery] = useState("");
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const navigate = useNavigate();

  const currentUrl = window.location.href;
  const urlParts = currentUrl.split('/');
  const url = urlParts[3]

  const Viewdetails = (emp_code, user_detail) => {
    navigate(`/${url}/userdetailscrud/${emp_code}/${user_detail}/`);
  };
  return (
    <>
      <button
        className=""
        title="View Employees"
        style={{ paddingLeft: "5px", color: "blue", fontSize: "14px" }}
        onClick={handleShow}
      >
        <BlueEye />
      </button>
      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Body>
          <>
            {/* <div className="attendance-history-cont">
              <div className="attendance-heading  font-weight500    font-size-heading"></div>
            </div> */}
            <div className="table-css-white-background">
              <div className="table-heading-flex">
                <div className="repo-heading font-weight500    font-size-heading">
                  {/* Employees for : <br /> */}
                  {title} ({dashboardEmployees?.filter(
                    (e) =>
                      e.name
                        .toLowerCase()
                        .includes(searchQuery.toLowerCase()) ||
                      e.emp_code
                        .toString()
                        .includes(searchQuery.toLowerCase())
                  ).length}/{dashboardEmployees.length})
                </div>
                <div className="flex-row">
                  <div className="table-searchh">
                    <div>
                      <SearchSmall />
                    </div>
                    <div>
                      <input
                        placeholder="Search"
                        className="navbar-inputt font-weight400  font-size-text"
                        value={searchQuery}
                        onChange={handleSearchChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <table className="table-css">
                <thead>
                  <tr className="custom-table-head-tr">
                    <th className="align-left">ID</th>
                    <th className="align-center">Emp Code</th>
                    <th className="align-center"> Name </th>
                    <th className="align-center">Employee View</th>
                  </tr>
                </thead>
                {buffer ? <div className="spinner"></div> : //buffering logic
                  <tbody>
                    {dashboardEmployees
                      ?.filter(
                        (e) =>
                          e.name
                            .toLowerCase()
                            .includes(searchQuery.toLowerCase()) ||
                          e.emp_code
                            .toString()
                            .includes(searchQuery.toLowerCase())
                      )
                      .sort((a, b) => a.emp_code - b.emp_code)
                      .map((i, index) => (
                        <React.Fragment key={index}>
                          {/* <tr className="tr-border-bottom">
                          <td colSpan="6"></td>
                        </tr> */}
                          <tr className="custom-table-head-td">
                            <td className="align-left">{index + 1}</td>
                            <td className="align-center">{i.emp_code}</td>
                            <td className="align-center">{i.name}</td>

                            <td className="align-center">
                              <button
                                className="employee-edit"
                                onClick={() =>
                                  Viewdetails(i.emp_code, i.user_detail)
                                }
                                title="View Profile"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="40"
                                  height="40"
                                  viewBox="0 0 30 30"
                                  fill="none"
                                >
                                  <circle cx="15" cy="15" r="15" fill="#F6F7F9" />
                                  <path
                                    d="M23.8913 14.5437C22.1966 11.2372 18.8416 9 15 9C11.1584 9 7.80249 11.2388 6.10873 14.5441C6.03725 14.6855 6 14.8417 6 15.0002C6 15.1586 6.03725 15.3148 6.10873 15.4563C7.80342 18.7628 11.1584 21 15 21C18.8416 21 22.1975 18.7612 23.8913 15.4559C23.9628 15.3145 24 15.1583 24 14.9998C24 14.8414 23.9628 14.6852 23.8913 14.5437ZM15 19.5C14.11 19.5 13.24 19.2361 12.4999 18.7416C11.7599 18.2471 11.1831 17.5443 10.8425 16.7221C10.5019 15.8998 10.4128 14.995 10.5865 14.1221C10.7601 13.2492 11.1887 12.4474 11.818 11.818C12.4474 11.1887 13.2492 10.7601 14.1221 10.5865C14.995 10.4128 15.8998 10.5019 16.7221 10.8425C17.5443 11.1831 18.2472 11.7599 18.7416 12.4999C19.2361 13.24 19.5 14.11 19.5 15C19.5003 15.591 19.3841 16.1763 19.1581 16.7224C18.932 17.2685 18.6005 17.7647 18.1826 18.1826C17.7647 18.6005 17.2685 18.932 16.7224 19.158C16.1763 19.3841 15.591 19.5003 15 19.5ZM15 12C14.7322 12.0037 14.4662 12.0436 14.2091 12.1184C14.421 12.4065 14.5227 12.7609 14.4957 13.1175C14.4688 13.4741 14.3149 13.8092 14.062 14.062C13.8092 14.3149 13.4741 14.4688 13.1175 14.4957C12.7609 14.5227 12.4065 14.421 12.1184 14.2091C11.9544 14.8133 11.984 15.4538 12.2031 16.0403C12.4221 16.6269 12.8196 17.1299 13.3396 17.4787C13.8595 17.8275 14.4758 18.0045 15.1016 17.9847C15.7274 17.965 16.3312 17.7495 16.8281 17.3685C17.325 16.9876 17.6899 16.4604 17.8715 15.8612C18.0531 15.2621 18.0422 14.621 17.8404 14.0283C17.6386 13.4356 17.256 12.9211 16.7465 12.5573C16.2369 12.1934 15.6261 11.9985 15 12Z"
                                    fill="#2576BC"
                                  />
                                </svg>
                              </button>
                            </td>
                          </tr>
                        </React.Fragment>
                      ))}
                  </tbody>
                }
              </table>
            </div>
          </>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </Modal.Body>
      </Modal>
    </>
  );
};

const EmployeeData = ({ customStyle = {} }) => {

  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = (today.getMonth() + 1).toString().padStart(2, '0');


  let previousYear = currentYear;
  let previousMonth = today.getMonth();




  if (previousMonth === 0) {
    previousYear--;
    previousMonth = 12;
  }


  const [selectedOption, setSelectedOption] = useState('this month');

  const [empData, setEmpData] = useState({});
  const [empTableData, setEmpTableData] = useState({});

  const getJobapppdata = async (selectedOption) => {
    try {
      const res = await axios.get(
        selectedOption === "this month"
          // ? `${BASE_URL}/wfm/employeestatus/${currentYear}/${currentMonth}/${sessionStorage.getItem('company_id')}/`
          // : `${BASE_URL}/wfm/employeestatus/${previousYear}/${previousMonth}/${sessionStorage.getItem('company_id')}/`
          ? `${BASE_URL}/wfm/employeestatusbysubcompany/${currentMonth}/${currentYear}/${sessionStorage.getItem('company_id')}/`
          : `${BASE_URL}/wfm/employeestatusbysubcompany/${previousMonth}/${previousYear}/${sessionStorage.getItem('company_id')}/`
        // ? `${BASE_URL}/wfm/employeestatus/${currentYear}/${currentMonth}/`
        // : `${BASE_URL}/wfm/employeestatus/${previousYear}/${previousMonth}/`
      );

      const response = await axios.get(
        selectedOption === "this month"
          ? `${BASE_URL}/wfm/employeebasicinfodashbord/${currentMonth}/${currentYear}/${sessionStorage.getItem('company_id')}/`
          : `${BASE_URL}/wfm/employeebasicinfodashbord/${previousMonth}/${previousYear}/${sessionStorage.getItem('company_id')}/`
      );

      setEmpData(res.data);
      setEmpTableData(response.data);
    } catch (err) {
      // handleAllError(err)
      // console.log(err)
    }
  };

  useEffect(() => {
    getJobapppdata(selectedOption);
  }, [selectedOption]);

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
  };



  return (
    <div style={{
      background: '#ffffff',
      borderRadius: '14px',
      padding: '20px',
      display: 'flex',
      flexDirection: 'column',
      gap: '13px',
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <div
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#eef2ff",
              color: "#2576bc",
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
          </div>
          <div style={{ fontSize: "15px", fontWeight: "600", color: "#0f172a" }}>
            Employees data
          </div>
        </div>
        <div className="radialchart-dropdown">
          <select style={{ border: "1px solid #E2E8F0", borderRadius: 8, padding: "5px 10px", fontSize: 12, fontWeight: 500, color: "#334155", background: "#fff", cursor: "pointer", outline: "none" }} onChange={handleChange}
            value={selectedOption}>
            <option value="this month">This Month</option>
            <option value="last month">Last Month</option>
          </select>
        </div>

        {/* <div style={{ display: 'flex', gap: '10px', alignItems: 'center', }}> */}
        {/* <div style={{ position: 'relative', flex: 1 }}>
            <select
              style={{
                borderRadius: '6px',
                padding: '8px 30px 8px 12px',
                outline: 'none',
                width: '100%',
                cursor: 'pointer',
                fontSize: '13px',
                fontWeight: '500'
              }}
              onChange={handleChange}
              value={selectedOption}
            >
              <option value="this month">This month</option>
              <option value="last month">Last month</option>
            </select>
            <div style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', display: 'flex', alignItems: 'center' }}>
              <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L5 5L9 1" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
          </div> */}
        {/* <button style={{
            border: 'none',
            borderRadius: '6px',
            padding: '8px 12px',
            fontSize: '14px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <svg width="16" height="4" viewBox="0 0 16 4" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="2" cy="2" r="1.5" fill="#a0a0a0" />
              <circle cx="8" cy="2" r="1.5" fill="#a0a0a0" />
              <circle cx="14" cy="2" r="1.5" fill="#a0a0a0" />
            </svg>
          </button> */}
        {/* </div> */}
      </div>
      <div className="db2-divider" style={{ margin: 0 }} />
      <div style={{
        display: 'flex',
        gap: '10px',
        ...customStyle,
        borderRadius: '8px',
        // border: '1px solid #E2E8F0',
        overflow: 'hidden',
        justifyContent: 'space-between',
        alignItems: 'stretch'
      }}>
        <div style={{ flex: 1, borderRight: '1px solid #E2E8F0', padding: '16px', boxShadow: 'inset 0 0 30px rgba(14, 125, 223, 0.12)', backgroundColor: '#2576bc30' }}>
          <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '8px', fontWeight: '500' }}>Total Employees</div>
          <div style={{ fontSize: '20px', fontWeight: '600', color: 'black' }}>{empData.total_employees_count || 0}</div>
        </div>
        <div style={{ flex: 1, borderRight: '1px solid #E2E8F0', padding: '16px', boxShadow: 'inset 0 0 30px rgba(10, 216, 86, 0.12)', backgroundColor: '#06ad0630' }}>
          <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '8px', fontWeight: '500' }}>Active Employees</div>
          <div style={{ fontSize: '20px', fontWeight: '600', color: 'black' }}>{(empData.active_employees_count || 0) - (empData.joined_employees_count || 0)}</div>
        </div>
        <div style={{ flex: 1, borderRight: '1px solid #E2E8F0', padding: '16px', boxShadow: 'inset 0 0 30px rgba(8, 207, 184, 0.12)', backgroundColor: '#3dcdcd30' }}>
          <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '8px', fontWeight: '500' }}>Onboard Employees </div>
          <div style={{ fontSize: '20px', fontWeight: '600', color: 'black' }}>{empData.joined_employees_count || 0}</div>
        </div>
        <div style={{ flex: 1, borderRight: '1px solid #E2E8F0', padding: '16px', boxShadow: 'inset 0 0 30px rgba(248, 244, 22, 0.12)', backgroundColor: '#f7ba1e30' }}>
          <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '8px', fontWeight: '500' }}>Inactive Employees</div>
          <div style={{ fontSize: '20px', fontWeight: '600', color: 'black' }}>{(empData.inactive_employees_count || 0) - ((empData.resigned_employees_count || 0) + (empData.terminated_employees_count || 0))}</div>
        </div>
        <div style={{ flex: 1, padding: '16px', boxShadow: 'inset 0 0 30px rgba(243, 38, 38, 0.12)', backgroundColor: '#ff747c30' }}>
          <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '8px', fontWeight: '500' }}>Separated Employees</div>
          <div style={{ fontSize: '20px', fontWeight: '600', color: 'black' }}>{(empData.resigned_employees_count || 0) + (empData.terminated_employees_count || 0)}</div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeData;
